import MultiSelectField from '../Placementdb/MultiSelectField';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FiltersPanel = ({
  // Data
  departments,
  skills,
  jobLocations,  // ⬅️ ADDED (was missing)
  experiences,
  statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'Open', label: 'Open' },
    { value: 'Cancelled', label: 'Cancelled' },
    { value: 'Closed', label: 'Closed' }
  ],
  createdByOptions = [],
  allowedBranchesOptions = [],  // ⬅️ NEW

  // Pending states
  pendingDepartments,
  pendingSkills,
  pendingJobLocations,  // ⬅️ ADDED (was missing)
  pendingExperiences,
  pendingStatus,
  pendingCreatedBy,
  pendingAllowedBranches,  // ⬅️ NEW
  pendingFromDate,         // ⬅️ NEW
  pendingToDate,           // ⬅️ NEW

  // Setters
  setPendingDepartments,
  setPendingSkills,
  setPendingJobLocations,  // ⬅️ ADDED (was missing)
  setPendingExperiences,
  setPendingStatus,
  setPendingCreatedBy,
  setPendingAllowedBranches,  // ⬅️ NEW
  setPendingFromDate,         // ⬅️ NEW
  setPendingToDate,           // ⬅️ NEW

  // Actions
  clearAllFilters,
  handleApplyFilters,
  isApplyingFilters,
  hasPendingChanges,
  handleMyOpenRequirements,
  showMyRequirements

}) => {

  const parseISO = (iso) => (iso ? new Date(iso) : null);

  const formatISO = (date) =>
    date ? date.toISOString().split("T")[0] : "";


  return (
    <div className="advanced-filters-panel">
      <div className="filters-grid">
        {/* Department Filter */}
        <MultiSelectField
          label="Department"
          options={departments}
          selectedValues={pendingDepartments}
          onChange={setPendingDepartments}
          placeholder="Select departments..."
          searchPlaceholder="Search departments..."
        />

        {/* Skills Filter */}
        <MultiSelectField
          label="Required Skills"
          options={skills}
          selectedValues={pendingSkills}
          onChange={setPendingSkills}
          placeholder="Select skills..."
          searchPlaceholder="Search skills..."
        />

        {/* ⬅️ NEW: Job Locations Filter */}
        <MultiSelectField
          label="Job Location"
          options={jobLocations}
          selectedValues={pendingJobLocations}
          onChange={setPendingJobLocations}
          placeholder="Select locations..."
          searchPlaceholder="Search locations..."
        />

        {/* Experience Filter */}
        {/* <MultiSelectField
          label="Experience Required"
          options={experiences}
          selectedValues={pendingExperiences}
          onChange={setPendingExperiences}
          placeholder="Select experience levels..."
          searchPlaceholder="Search experience..."
        /> */}

        {/* Status Filter (Single Select) */}
        <MultiSelectField
          label="Job Status"
          options={statusOptions.map(s => s.value).filter(Boolean)}
          selectedValues={Array.isArray(pendingStatus) ? pendingStatus : []}
          onChange={setPendingStatus}
          placeholder="Select status..."
          searchPlaceholder="Search status..."
        />

        {/* Created By Filter */}
        <MultiSelectField
          label="Created By"
          options={createdByOptions}
          selectedValues={pendingCreatedBy}
          onChange={setPendingCreatedBy}
          placeholder="Select created by..."
          searchPlaceholder="Search created by..."
        />

        {/* ⬅️ NEW: Allowed Branches Filter */}
        <MultiSelectField
          label="Allowed Branches"
          options={allowedBranchesOptions}
          selectedValues={pendingAllowedBranches}
          onChange={setPendingAllowedBranches}
          placeholder="Select branches..."
          searchPlaceholder="Search branches..."
        />

        {/* ⬅️ NEW: Date Range Filters */}
        {/* From Date */}
        <div className="multi-select-field">
          <label>From Date:</label>
          <DatePicker
            selected={parseISO(pendingFromDate)}
            onChange={(date) => setPendingFromDate(formatISO(date))}
            dateFormat="dd/MM/yyyy"      // ✅ SAME FORMAT EVERYWHERE
            placeholderText="DD/MM/YYYY"
            className="date-input"
          />
        </div>

        {/* To Date */}
        <div className="multi-select-field">
          <label>To Date:</label>
          <DatePicker
            selected={parseISO(pendingToDate)}
            onChange={(date) => setPendingToDate(formatISO(date))}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            className="date-input"
          />
        </div>


      </div>

      <div className="filters-actions">
        <button
          onClick={handleMyOpenRequirements}
          className="my-open-req-btn"
        >
          {
            showMyRequirements
              ? "Show All Requirements"
              : "My Open Requirements"
          }
        </button>
        <button onClick={clearAllFilters} className="clear-btn">
          Clear All Filters
        </button>

        <button
          onClick={handleApplyFilters}
          className="apply-filters-btn"
          disabled={isApplyingFilters || !hasPendingChanges()}
        >
          {isApplyingFilters ? (
            <>
              <span className="loading-spinner">⟳</span>
              Applying...
            </>
          ) : (
            <>
              <span>✓</span>
              Apply Filters
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default FiltersPanel;